// don't remove
import * as TapEventPlugin from '../common/TapEventPlugin'

import * as React from "react";
import {List, ListItem} from 'material-ui/List';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import ActionInfo from 'material-ui/svg-icons/action/info';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FloatingActionButton from "material-ui/FloatingActionButton";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";
import NewTuning from "./NewTuning";
import AvatarPlus from "../common/AvatarPlus";



declare global {
    interface Window {
        initialState: any;
        app : any;
    }
}

export default class TuningsList extends React.Component<any, any> {
    userAgent : string;

    constructor(props: any) {
        super(props);
        let t = Object.keys(props).length > 0 ? this.props : window.initialState;
        t.dialogShown = false;
        this.state = t;
        this.userAgent = props.userAgent ? props.userAgent : navigator.userAgent;
    }

    // componentDidMount() {
    //     this.setState({tunings : [{"name" : 123}]});
    // }

    handleDialogOpen (event) {
        if (!window.app.userBar.ensureAuth()) return;
        this.setState({dialogShown: true});
    };

    handleDialogClose (event) {
        this.setState({dialogShown: false});
    };

    handleListItemClick (shortName) {
        location.href = "/chords/" + this.state.instrument + "/" + shortName;
    };

    render() {
        const {tunings} = this.state;
        const items = tunings.map(t => {
            return <ListItem key={t.name} onClick={this.handleListItemClick.bind(this, t.shortName)} primaryText={<a href={"/chords/" + this.state.instrument + "/" + t.shortName}>{t.name}</a>} secondaryText={t.notes} rightIcon={
                <a href={"/user/" + t.createdBy.username}>
                    <AvatarPlus src={t.createdBy.picture} size={28} />
                </a>
            } />
        });
        const buttonStyle = {
        };


        return <MuiThemeProvider muiTheme={getMuiTheme({userAgent: this.userAgent })}>
            <div>
                <RaisedButton label="New Tuning" primary={true} style={buttonStyle} onClick={this.handleDialogOpen.bind(this)} />
                <br />
                <List>
                {items}
                </List>

                <NewTuning dialogShown={this.state.dialogShown} instrument={this.state.instrument} dialogClose={this.handleDialogClose.bind(this)} />
            </div>
        </MuiThemeProvider>
    }
}


// WEBPACK FOOTER //
// ./components/guitar/TuningsList.tsx